import { createSelector } from 'reselect';

const selectProductions = (state: any) => state.productions;


export const selectProductionsCurrentItem = createSelector([selectProductions], (productions) => productions.current);

export const selectProductionsListItems = createSelector([selectProductions], (productions) => productions.list);

export const selectProductionsItemById = (itemId: any) =>
    createSelector(selectProductionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProductionsQueryItems = createSelector([selectProductions], (productions) => productions.query);

export const selectProductionsCreatedItem = createSelector([selectProductions], (productions) => productions.create);

export const selectProductionsUpdatedItem = createSelector([selectProductions], (productions) => productions.update);

export const selectProductionsReadItem = createSelector([selectProductions], (productions) => productions.read);

export const selectProductionsDeletedItem = createSelector([selectProductions], (productions) => productions.delete);

export const selectProductionsSearchedItems = createSelector([selectProductions], (productions) => productions.search);

export const selectProductionsItemsCount = createSelector([selectProductions], (productions) => productions.count);

export const selectProductionsItemsFilter = createSelector([selectProductions], (productions) => productions.filter);